// extracted by mini-css-extract-plugin
export default {"CallActive2Content":"CallActive2St_CallActive2Content__eUkie","colorActive":"CallActive2St_colorActive__toTz8","boxSend":"CallActive2St_boxSend__9-24D"};